import { Link } from "react-router-dom";

const contentLinks = [
  { label: "首页", to: "/" },
  { label: "影片资源分类", to: "/category" },
  { label: "专题合辑", to: "/special" },
  { label: "关于本站", to: "/about" },
];

const chapterLinks = [
  { label: "第 1 章 · 牌桌上的暗流", to: "/detail/chapter-01" },
  { label: "第 4 章 · 珠宝店与镜子", to: "/detail/chapter-04" },
  { label: "第 8 章 · 最后一颗钻石", to: "/detail/chapter-08" },
  { label: "第 12 章 · 尘埃落定之后", to: "/detail/chapter-12" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-100 text-foreground-800 md:mt-24">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg leading-none text-background-50">
                戒
              </span>
              <span className="font-heading text-lg text-foreground-950">色戒无删减版</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-800">
              影视内容与剧情解析平台，围绕影片完整章节、剧情脉络与幕后解读，为影迷提供清晰的浏览与检索体验。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md border border-foreground-950/15 px-3 py-1.5 text-xs text-foreground-800">
              <i className="ri-information-line text-sm leading-none text-accent-500" />
              播放区域为前端演示，暂未接入播放入口
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-accent-500">网站导航</h4>
            <ul className="mt-4 space-y-2.5">
              {contentLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-800 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-accent-500">热门章节</h4>
            <ul className="mt-4 space-y-2.5">
              {chapterLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-800 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-accent-500">声明与说明</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-800">
              本站为影视资讯与剧情介绍类演示站点，所有文字内容均为原创解说，影片资料仅作示例展示。本站不存储、不提供任何影片文件下载。
            </p>
            <div className="mt-4 flex flex-wrap gap-3 text-xs text-foreground-800/90">
              <Link to="/about#disclaimer" className="underline decoration-foreground-950/25 underline-offset-4">
                免责声明
              </Link>
              <Link to="/about#privacy" className="underline decoration-foreground-950/25 underline-offset-4">
                隐私说明
              </Link>
              <Link to="/about#contact" className="underline decoration-foreground-950/25 underline-offset-4">
                联系反馈
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-foreground-950/15 pt-6 text-xs text-foreground-800/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 色戒无删减版 · 影视内容演示站 · 仅供学习与界面演示</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>站内引用影片资料仅作示例</span>
            <span className="hidden sm:inline text-foreground-950/25">|</span>
            <span>建议在 PC 端 1440px 宽度下浏览</span>
          </p>
        </div>
      </div>
    </footer>
  );
}